import { getToken, removeLogin, setLogin, setOffice } from "./auth";
import { API_ENDPOINT } from "./const";

export async function orgSelect(org) {
    let res_text = "";
    const res = await fetch(API_ENDPOINT + "organization/get?org=" + org);
    if (res.status === 200) {
        res_text = await res.json();
        setOffice(res_text.office_id);
        return true;
    } else {
        throw await res.json();
    }
}

export async function orgSearch(text) {
    const res = await fetch(API_ENDPOINT + "organization/search?org=" + text);
    if (res.status === 200)
        return await res.json();
    return [];
}


export async function userLogin(company, username, password) {
    const res = await fetch(API_ENDPOINT + "user/login", {
        method: 'POST',
        body: JSON.stringify({
            "office": company,
            "user": username,
            "password": password,
            "source": "Web"
        })
    });
    if (res.status === 200) {
        const data = await res.json();
        setOffice(company);
        setLogin(data.token, data.role, data.userid, data.accid, data.username, data.name);
        return true;
    } else {
        throw await res.json();
    }
}

export async function logout() {
    const res = await fetch(API_ENDPOINT + "user/logout/" + getToken());
    removeLogin();
    if (res.status === 200) {
        await res.json();
        return true;
    } else {
        await res.json();
        return false;
    }
}
